var map = {
	"./Snipaste_2024-08-03_17-17-09.jpg": 77950,
	"./Snipaste_2024-08-03_17-17-32.jpg": 57404,
	"./Snipaste_2024-08-03_17-17-52.jpg": 10842,
	"./feitian.png": 78589,
	"./juxing.png": 98446,
	"./lanyue.png": 2377
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75398;